module.exports = __webpack_public_path__ + "static/img/time-line-mob-red-ar.e2cf53d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/red-about/time-line-mob-red-ar.png
// module id = 1240
// module chunks = 4